import React, { useState } from "react";
import "./ProductReview.css";
import productReviewData from "../../../../DummyData/ProductReviewData";

const ProductReview = () => {
  return (
    <div className="reviewProd-outer-wrapper">
      <div className="heading-wrapper">
        <h5>
          <u>Product 1 Review Responses</u>
        </h5>
      </div>
      <div className="reviewData-container">
        <div className="data-column">
          <p className="data-tab dataName">
            <u>
              <b>Participant Name</b>
            </u>
          </p>
          <p className="data-tab dataEmail">
            <u>
              <b>Email</b>
            </u>
          </p>
          <p className="data-tab">
            <u>
              <b>Submitted on</b>
            </u>
          </p>
          <p className="data-tab">
            <u>
              <b>Survey</b>
            </u>
          </p>
          <p className="data-tab">
            <u>
              <b>Prototype</b>
            </u>
          </p>
        </div>
        {productReviewData.map((item) => (
          <div className="data-column border-bottom">
            <p className="data-tab dataName">{item.participantName}</p>
            <p className="data-tab dataEmail">{item.email}</p>
            <p className="data-tab">{item.submitDate}</p>
            <p className="data-tab">
              
              <a href="#" className="links">
                {item.survey}
              </a>
            </p>
            <p className="data-tab">
              <a href="#" className="links">
                {item.protoType}
              </a>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
export default ProductReview;
